module.exports = __webpack_public_path__ + "2d6d918c4c3269f4b85148a7857de470.pdf";